import { useEffect, useState } from "react";

function diff(targetIso, serverIso) {
  const now = new Date();
  // approximate offset between server & client at mount
  const target = new Date(targetIso).getTime();
  const delta = target - now.getTime();
  const clamped = Math.max(0, delta);
  const d = Math.floor(clamped / 86400000);
  const h = Math.floor((clamped % 86400000) / 3600000);
  const m = Math.floor((clamped % 3600000) / 60000);
  const s = Math.floor((clamped % 60000) / 1000);
  return { d, h, m, s, done: clamped <= 0 };
}

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ targetIso, serverIso, onComplete }) {
  const [t, setT] = useState(() => diff(targetIso, serverIso));
  useEffect(() => {
    const id = setInterval(() => {
      const nt = diff(targetIso, serverIso);
      setT(nt);
      if (nt.done && onComplete) onComplete();
    }, 1000);
    return () => clearInterval(id);
  }, [targetIso, serverIso, onComplete]);

  const items = [
    { v: t.d, l: "DIAS" },
    { v: t.h, l: "HORAS" },
    { v: t.m, l: "MINUTOS" },
    { v: t.s, l: "SEGUNDOS" },
  ];
  return (
    <div className="flex items-start justify-center gap-4 sm:gap-8" data-testid="countdown">
      {items.map((it, i) => (
        <div key={it.l} className="flex items-start">
          <div className="flex flex-col items-center">
            <span className="font-mono text-3xl sm:text-5xl font-light tracking-tighter metallic-text">
              {pad(it.v)}
            </span>
            <span className="mt-2 text-[10px] tracking-[0.25em] text-white/40">{it.l}</span>
          </div>
          {i < items.length - 1 && (
            <span className="font-mono text-2xl sm:text-4xl text-white/20 mx-2 sm:mx-3 leading-none">:</span>
          )}
        </div>
      ))}
    </div>
  );
}
